import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "columns", "textAlign", "verticalAlign"];
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Grid } from 'semantic-ui-react';
import _chunk from 'lodash/chunk';
import _isEmpty from 'lodash/isEmpty';
import CTA from './CTA';
import { getTextAlignClass, getVerticalAlignClass } from './utils';
import { ChildrenPropType, TextAlignPropType, VerticalAlignPropType } from '../../services/proptypes';
import './CallToActionBanner.css';
function CallToActionBanner(_ref) {
  var children = _ref.children,
    columns = _ref.columns,
    textAlign = _ref.textAlign,
    verticalAlign = _ref.verticalAlign,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var childrenCount = React.Children.count(children);
  if (childrenCount === 0) {
    return null;
  }
  var finalColumns = columns || childrenCount || 16;
  var rowsWithChildren = _chunk(React.Children.toArray(children), finalColumns);
  var extraClasses = [getTextAlignClass(textAlign), getVerticalAlignClass(verticalAlign)].join(' ');
  if (finalColumns === 0 || _isEmpty(rowsWithChildren)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Grid, _extends({
    className: "cta-banner ".concat(extraClasses),
    columns: finalColumns
  }, extraProps), rowsWithChildren.map(function (rowChildren, idx) {
    return /*#__PURE__*/React.createElement(Grid.Row, {
      columns: rowChildren.length,
      key: "cta-banner-row-".concat(idx),
      className: "cta-banner-row"
    }, rowChildren);
  }));
}
CallToActionBanner.defaultProps = {
  columns: null,
  children: null,
  textAlign: 'center',
  verticalAlign: 'middle'
};
CallToActionBanner.CTA = CTA;
export default CallToActionBanner;